module.exports = __webpack_public_path__ + "img/partydynamic2.8fb60fae.png";